// utils/session.js
export const isSessionValid = () => {
    const adminData = localStorage.getItem("admin");
    if (!adminData) return false;

    try {
        const admin = JSON.parse(adminData);
        const now = new Date().getTime();
        return admin?.expiry > now;
    } catch {
        return false;
    }
};

export const setSession = (adminData) => {
    const expiry = new Date().getTime() + 30 * 60 * 1000; // 30 minutes
    localStorage.setItem("admin", JSON.stringify({ ...adminData, expiry }));
};

export const clearSession = () => {
    localStorage.removeItem("admin");
};
